import { useState } from 'react'

import { useIntersectionObserver } from '../useIntersectionObserver'

export function useVisibilityTrigger({ callback, options }) {
  const [element, setElement] = useState(null)
  const [hasTriggered, setHasTriggered] = useState(false)

  async function observerCallback(entries) {
    const [entry] = entries

    if (entry.isIntersecting && !hasTriggered) {
      await callback()
      setHasTriggered(true)
    }
  }

  // `setElement` is a callback ref: attaching it re-renders with the live node,
  // so the observer subscribes once the element actually mounts.
  useIntersectionObserver({
    observerCallback,
    observerOptions: options,
    thresholdElement: element,
  })

  return { elementRef: setElement, viewed: hasTriggered }
}
